export default __webpack_public_path__ + "static/media/cooper-1.47b10586.jpg";